import React, { FC, ReactNode } from 'react';

import styled from '@emotion/styled';
import {
  compose,
  TypographyProps,
  typography,
  SpaceProps,
  space,
  FlexboxProps,
  flexbox,
  border,
  BorderProps,
  BackgroundProps,
  background,
  variant,
  ComponentsType
} from '@lucid/theme';
import { AccordionItemHeading } from 'react-accessible-accordion';

import { HeadingTagsType } from '../heading/heading';

export type AccordionHeaderAriaLevel = 1 | 2 | 3 | 4 | 5 | 6;
export type AccordionHeadingTagType = HeadingTagsType;

export interface AccordionHeadingProps
  extends BackgroundProps,
  BorderProps,
  TypographyProps,
  SpaceProps,
  FlexboxProps {
  /** Sets the HTML tag element for the heading. */
  as?: HeadingTagsType;
  /** The children passed into the Accorion.Heading */
  children?: ReactNode;
  /** The available variants for the `Accordion.Heading` component. */
  variant?: ComponentsType['Accordion']['Heading'];
}

export interface AccordionItemHeadingProps {
  /** Sets the aria heading value for accessibility. */
  'aria-level'?: AccordionHeaderAriaLevel
}

const accordionHeadingStyleProp = compose(
  background,
  border,
  flexbox,
  typography,
  space
);

const StyledAccordionHeading = styled(AccordionItemHeading)<AccordionItemHeadingProps & AccordionHeadingProps>(
  variant({
    scale: 'accordion.heading',
    variants: {
      defaultVariant: {}
    }
  }),
  {
    label: 'heading',
    width: '100%'
  },
  accordionHeadingStyleProp
);

const AccordionHeading: FC<AccordionHeadingProps> = ({ as, ...rest }) => {
  const ariaLevel = as
    ? parseInt(as.slice(1), 10) as AccordionHeaderAriaLevel
    : 3;

  return (
    <StyledAccordionHeading aria-level={ariaLevel} {...rest} />
  );
};

export { AccordionHeading };
export default AccordionHeading;
